import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, VideoStopResult } from '../types';
import { EVENTS } from '../constants';
import { mapBase } from './mapBase';
import { getFormattedOriginalSourcePage } from '../utils';

export const mapVideoStop = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): VideoStopResult | undefined => {
    const progressPct = Math.round(parseFloat(payload.payload.percentOfPlayback.toFixed(2)));
    return {
        ...mapBase(payload),
        action: EVENTS.VIDEO_STOP,
        event_trigger: triggerName,
        thing_id: payload.payload.asset?.id || '',
        progress_pct: progressPct,
        source_page: getFormattedOriginalSourcePage(payload),
        source_rail: payload.payload.asset.sectionLabel,
        duration: payload.payload.duration,
    };
};
